import { stripLocalePrefix } from '../routes/publicPaths';

const PATH_LABEL_KEYS = {
  '/': 'public.nav.home',
  '/programmes': 'public.nav.allPrograms',
  '/about': 'public.nav.whoWeAre',
  '/stats': 'public.nav.statistics',
  '/donate': 'public.nav.donate',
  '/volunteer': 'public.nav.volunteer',
  '/actualites': 'public.nav.news',
  '/legal': 'public.nav.legal',
  '/programmes/adahi': 'public.programs.adahi',
  '/programmes/namaa': 'public.programs.namaa',
  '/programmes/ighatha': 'public.programs.ighatha',
  '/programmes/caravane': 'public.programs.caravane',
  '/programmes/ramadan': 'public.programs.ramadan',
  '/programmes/saqya': 'public.programs.saqya',
  '/programmes/kafala': 'public.programs.kafala',
  '/programmes/omra': 'public.programs.omra',
};

const GROUP_LABEL_KEYS = {
  'مشاريع أخرى': 'public.nav.otherProjects',
  'عن صحبة الخير': 'public.nav.aboutGroup',
};

export const tProgramTitle = (t, slug, fallback) => {
  if (!slug) return fallback || '';
  return t(`public.programs.${slug}`, { defaultValue: fallback || slug });
};

export const tProgramDescription = (t, slug, fallback) => {
  if (!slug) return fallback || '';
  return t(`public.programDescriptions.${slug}`, { defaultValue: fallback || '' });
};

export const tNavItemName = (t, item) => {
  if (item?.slug) return tProgramTitle(t, item.slug, item.name);
  if (item?.path) {
    const pathKey = PATH_LABEL_KEYS[stripLocalePrefix(item.path)];
    if (pathKey) return t(pathKey, { defaultValue: item.name });
  }
  if (item?.children) {
    const groupKey = GROUP_LABEL_KEYS[item.name];
    if (groupKey) return t(groupKey, { defaultValue: item.name });
  }
  return item?.name || '';
};

export const tProgramNavLabel = (t, slug, item) => {
  if (!item) return '';
  return t(`public.programNav.${slug}.${item.id}`, {
    defaultValue: t(`public.programNav.common.${item.id}`, { defaultValue: item.label }),
  });
};
